import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { OfficeRulesList } from './../Data' 
import { useState } from 'react';
import './../style/OfficeRules.css'

 const OfficeRules = () => {
  let [isActiveBtn, setActiveBtn] = useState(false)

  function changeBtnColor(e) {
    const accordionBtns = document.querySelectorAll('.szh-accordion__item-btn')
    if (e.target.classList.contains('szh-accordion__item-btn')) {
      if (!e.target.classList.contains('accordion-active-btn')) {
        setActiveBtn(!isActiveBtn)
        accordionBtns.forEach(item => item.classList.remove('accordion-active-btn'))
        e.target.classList.add('accordion-active-btn')
      }
      else {
          setActiveBtn(isActiveBtn = false)
        e.target.classList.remove('accordion-active-btn')
      }
    }
  }
  return (
    <div className="office-rules-container" id='Office-rules'>
      <h2 className='rules-title'>Правила посещения студии</h2>
      <Accordion >
        {OfficeRulesList.map(({ header, content}, i) => (
          <AccordionItem 
            className='accordion'
            header={header}
            key={i}
            onClick={changeBtnColor}
          >
            <span className='accordion-item'>{content}</span>            
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default OfficeRules